import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import Container from "../components/Container";
import Button from "../components/Button";
import AuthCard from "../components/AuthCard";
import AuthHeader from "../components/AuthHeader";
import InputField from "../components/InputField";
import { toast } from "react-hot-toast";
import { api } from "../services/http";
import { FaEye, FaEyeSlash } from "react-icons/fa";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const [formData, setFormData] = useState({
    email: searchParams.get("email") || "",
    token: searchParams.get("token") || "",
    password: "",
    password_confirmation: "",
  });
  
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (!formData.token || !formData.email) {
      toast.error("Lien de réinitialisation invalide ou expiré");
      navigate("/login");
    }
  }, [formData.token, formData.email, navigate]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.password !== formData.password_confirmation) {
      return toast.error("Les mots de passe ne correspondent pas");
    }

    setLoading(true);
    try {
      const res = await api.auth.resetPassword(formData);
      if (res.success) {
        toast.success("Mot de passe réinitialisé avec succès !");
        setTimeout(() => navigate("/login"), 2000);
      } else {
        toast.error(res.message || "Une erreur est survenue");
      }
    } catch (error) {
      toast.error(error.message || "Erreur lors de la réinitialisation");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="min-h-screen bg-gradient-to-br from-[#E9FBF8] via-white to-[#FFEFD8] bg-bg-login bg-contain bg-bottom flex items-center justify-center py-10">
      <AuthCard>
        <AuthHeader />
        
        <div className="mt-6 text-center">
          <h2 className="text-[20px] font-bold text-[#1B1C33]">
            Nouveau mot de passe
          </h2>
          <p className="text-[14px] text-[#6B7280] mt-2">
            Veuillez choisir votre nouveau mot de passe.
          </p>
        </div>

        <form className="mt-8 space-y-5" onSubmit={handleSubmit}>
          <InputField
            label="Email"
            type="email"
            name="email"
            value={formData.email}
            disabled
            required
          />

          <div>
            <label className="block text-[14px] font-medium text-[#1B1C33]">
              Nouveau mot de passe
            </label>
            <div className="relative mt-2.5">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={formData.password}
                onChange={handleChange}
                className="w-full rounded-[7px] border border-[#C1BECE] px-4 py-2 text-[14px] focus:outline-none focus:ring-2 focus:ring-[#FEA12B]/60 pr-10"
                required
                minLength={8}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-[#1B1C33] hover:text-[#FEA12B] transition-colors"
              >
                {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
              </button>
            </div>
          </div>

          <InputField
            label="Confirmer le mot de passe"
            type="password"
            name="password_confirmation"
            value={formData.password_confirmation}
            onChange={handleChange}
            required
          />

          <div className="flex pt-4">
            <Button
              type="submit"
              className="w-full py-2.5 text-[14px]"
              disabled={loading}
            >
              {loading ? "Réinitialisation..." : "Réinitialiser le mot de passe"}
            </Button>
          </div>
        </form>
      </AuthCard>
    </Container>
  );
}
